import styled from 'styled-components';
import { DropDownOptionsList as BaseDropDownOptionsList } from 'src/styles/dropDown.style';

export const CloseIcon = styled.div`
    position: absolute;
    right: 0;
    top: -8px;
`;

export const ToggleIconButton = styled.div`
    position: absolute;
    right: 0px;
    top: 0;
    color: rgb(136, 136, 136);
    border-left: 1px solid #ccc;
    padding: 10px;
    display: flex;
    align-items: center;
    width: 36px;
    height: 100%;
    border-left: 1px solid #ccc;
    padding-left: 7px;
    color: ${({ theme }) => theme.colors.text.lightGrey};
`;

export const DDWrapper = styled.span`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const DDLabel = styled.span`
    min-width: 80px;
`;

export const RotationContainer = styled.div`
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 30px;
    border: 1px solid ${({ theme }) => theme.colors.border.ccc};
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.background.white};
    padding: 4px;
    min-width: 250px;
`;

export const TradeNameInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const TradeNameText = styled.div`
    flex: 1;
    padding-right: 24px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    line-height: 1.2;
    min-height: 1.2em;
`;

export const ProductNameText = styled.div`
    color: ${({ theme }) => theme.colors.text.lightGrey};
    font-size: 0.9em;
    padding-right: 24px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    line-height: 1.2;
    min-height: 1.2em;
`;

export const DropDownOptionsList = styled(BaseDropDownOptionsList)`
    position: absolute;
    top: 28px;
    left: 0;
    z-index: 13;
    width: 370px;
`;

export const DropDownListContainer = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin-top: 4px;
`;

export const DropDownContainer = styled.div`
    position: relative;
`;

export const RotationItem = styled.div``;

export const SelectedListItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    cursor: pointer;
`;

export const ClearButton = styled.button`
    position: absolute;
    right: 36px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    color: #999;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;

    &:hover {
        color: #666;
    }
`;
